import { render, staticRenderFns } from "./LeagueTierTabs.vue?vue&type=template&id=065eb94b&scoped=true"
import script from "./LeagueTierTabs.vue?vue&type=script&lang=js"
export * from "./LeagueTierTabs.vue?vue&type=script&lang=js"
import style0 from "./LeagueTierTabs.vue?vue&type=style&index=0&id=065eb94b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065eb94b",
  null
  
)

export default component.exports